var path = 'common/toggle/toggle.html';
var html = "<div class=toggle ng-class=vm.getStyleClasses() ng-click=vm.click()></div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


/*****************
 ** WEBPACK FOOTER
 ** ./app/common/toggle/toggle.html
 ** module id = 160
 ** module chunks = 0
 **/